import { Component, OnInit, ViewChild, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { PriorityStore } from "@app/services/store/priority-store";
import { PlanningSegment } from "@app/models/rest/planning-segment";
import { Priority } from "@app/models/rest/priority";
import { MatSelectionList, MatListOption } from "@angular/material/list";
import { firstValueFrom } from "rxjs";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "../dialog-header/dialog-header.component";

@Component({
  selector: "app-priority-code-chooser",
  templateUrl: `priority-chooser.component.html`,
  styleUrls: ["./priority-chooser.component.scss"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatSelectionList,
    MatListOption,
    MatDialogActions,
    MatButton,
    DialogHeaderComponent
  ]
})
export class PriorityChooserComponent implements OnInit {
  priorityStore = inject(PriorityStore);
  dialogRef = inject<MatDialogRef<PriorityChooserComponent>>(MatDialogRef);
  protected serviceErrorHandler = inject(ServiceErrorHandlerService);
  data = inject<{
    segment: PlanningSegment;
  }>(MAT_DIALOG_DATA);

  @ViewChild("prioritySelection", { static: false })
  prioritySelection: MatSelectionList;

  public priorities: Priority[] = [];
  selectedPriorities: Priority[] = [];

  ngOnInit(): void {
    // Preselect existing filter priorities
    if (this.data.segment) {
      this.selectedPriorities = this.data.segment.filterPriorities || [];
    }
    this.priorityStore.loadAll().then((value) => {
      this.priorities = value.resources;
    });
  }

  isSelected(p: Priority) {
    return this.selectedPriorities.some((sel) => sel.id === p.id);
  }

  async save() {
    const chosen = this.prioritySelection.selectedOptions.selected.map(
      (opt) => opt.value as Priority
    );
    let segment: PlanningSegment = this.data.segment;

    try {
      // Unbind current priorities
      await firstValueFrom(
        segment.unbindCollectionRelation("filterPriorities")
      );

      // Add chosen priorities (only if there are any to add)
      if (chosen.length > 0) {
        await firstValueFrom(
          segment.addCollectionRelation("filterPriorities", chosen)
        );
      }

      this.dialogRef.close(true);
    } catch (error) {
      this.serviceErrorHandler.handleClientError(error);
    }
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }
}
